// TODO: expose these as first-class constructs from the router to make this contract more well-known
export const ONBOARDING_FIRM_ORG_SLUG_PARAM = "orgSlug"
export const ONBOARDING_AFFILIATION_LE_SLUG_PARAM = "leSlug"
